import { DataTableContainer } from 'ui';

export const ContractTabContent = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <DataTableContainer className='mt-4'>{children}</DataTableContainer>;
};
